module.exports = __webpack_public_path__ + "static/media/Illustration.f690dea4.png";